document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = () => window.matchMedia("(min-width: 1100px)").matches;

  const headerWrapper = document.querySelector(".as-header-wrapper");
  const drawer = document.querySelector(".as-mob-drawer");

  let closeTimeout;
  let activeSubmenuItem = null;
  let isInsideMega = false;

  function getHeaderHeight() {
    return Math.ceil(headerWrapper?.getBoundingClientRect().height || 0);
  }

  function syncHeaderOffset() {
    if (!headerWrapper) return;

    const height = getHeaderHeight();

    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`,
    );
  }

  syncHeaderOffset();

  window.addEventListener("load", syncHeaderOffset);
  window.addEventListener("resize", syncHeaderOffset);

  function activateFirstSubmenuItem(detailsEl) {
    const firstItem = detailsEl.querySelector(".as-header__submenu-item");
    if (!firstItem) return;

    const handle = firstItem.dataset.handle;

    firstItem.classList.add("is-active");
    activeSubmenuItem = firstItem;

    document
      .querySelectorAll(".submenu-products:not(.submenu-products--static)")
      .forEach((productBlock) => {
        productBlock.hidden = true;
      });

    const target = detailsEl.querySelector(
      `.submenu-products[data-handle="${handle}"]`,
    );

    if (target) target.hidden = false;
  }

  function closeAllMega(exceptEl) {
    document.querySelectorAll(".as-header__details").forEach((el) => {
      if (el !== exceptEl) {
        el.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.querySelectorAll(".as-header__submenu").forEach((submenu) => {
    submenu.addEventListener("mouseenter", () => {
      isInsideMega = true;
      clearTimeout(closeTimeout);
    });

    submenu.addEventListener("mouseleave", () => {
      isInsideMega = false;

      closeTimeout = setTimeout(() => {
        if (!isInsideMega && activeSubmenuItem) {
          activeSubmenuItem.classList.remove("is-active");
          activeSubmenuItem = null;
        }
      }, 120);
    });
  });

  document.querySelectorAll(".as-header__details").forEach((details) => {
    details.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;

      clearTimeout(closeTimeout);

      closeAllMega(details);
      details.setAttribute("aria-expanded", "true");
      headerWrapper?.classList.add("is-mega-open");

      if (!activeSubmenuItem) {
        activateFirstSubmenuItem(details);
      }
    });

    details.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;

      closeTimeout = setTimeout(() => {
        details.setAttribute("aria-expanded", "false");

        const anyOpen = document.querySelector(
          '.as-header__details[aria-expanded="true"]',
        );

        if (!anyOpen) {
          headerWrapper?.classList.remove("is-mega-open");
        }
      }, 120);
    });
  });

  document.querySelectorAll(".as-header__submenu-item").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const handle = item.dataset.handle;

      if (activeSubmenuItem && activeSubmenuItem !== item) {
        activeSubmenuItem.classList.remove("is-active");
      }

      item.classList.add("is-active");
      activeSubmenuItem = item;

      document
        .querySelectorAll(".submenu-products:not(.submenu-products--static)")
        .forEach((productBlock) => {
          productBlock.hidden = true;
        });

      const target = document.querySelector(
        `.submenu-products[data-handle="${handle}"]`,
      );

      if (target) target.hidden = false;
    });
  });

  let setActiveTab = () => {};

  document.querySelectorAll(".as-mob-header__burger").forEach((burger) => {
    burger.addEventListener("click", () => {
      if (!headerWrapper) return;

      const isOpen = headerWrapper.classList.contains(
        "as-header-wrapper--open",
      );

      headerWrapper.classList.toggle("as-header-wrapper--open");
      document.body.classList.toggle("as-fixed", !isOpen);

      if (!isOpen && drawer) {
        setActiveTab("shop", true);
      }
    });
  });

  if (drawer) {
    const backBtn = drawer.querySelector(".as-mob-back");
    const titleEl = drawer.querySelector(".as-mob-head-title");
    const headEl = drawer.querySelector(".as-mob-head");

    const stack = [{ level: 1, menuId: null, title: "" }];

    function render() {
      const state = stack[stack.length - 1];

      drawer.setAttribute("data-current-menu-level", state.level);
      drawer.setAttribute("data-current-menu-title", state.title || "");

      if (headEl) {
        headEl.style.display = state.level === 1 ? "none" : "flex";
      }

      if (titleEl) {
        titleEl.textContent = (state.title || "").toUpperCase();
      }

      if (backBtn) {
        backBtn.hidden = stack.length <= 1;
      }

      drawer.querySelectorAll(".as-mob-panel").forEach((panel) => {
        panel.hidden = true;
      });

      if (state.menuId) {
        const panel = drawer.querySelector(
          `.as-mob-panel[data-menu-id="${state.menuId}"]`,
        );

        if (panel) {
          panel.hidden = false;
        }
      }
    }

    function resetLevels() {
      stack.length = 1;
      render();
    }

    setActiveTab = (tab, reset = false) => {
      drawer.setAttribute("data-active-tab", tab);

      drawer.querySelectorAll(".as-mob-tab").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.tab === tab);
      });

      drawer.querySelectorAll(".as-mob-tab-panel").forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.panel === tab);
      });

      const showLevels = tab === "shop";

      drawer.querySelectorAll(".as-mob-level").forEach((level) => {
        level.style.display = showLevels ? "" : "none";
      });

      if (reset || !showLevels) {
        resetLevels();
      } else {
        render();
      }
    };

    drawer.addEventListener("click", (event) => {
      const tabBtn = event.target.closest(".as-mob-tab");

      if (tabBtn) {
        setActiveTab(tabBtn.dataset.tab);
        return;
      }

      if (drawer.getAttribute("data-active-tab") !== "shop") return;

      const nextLevelBtn = event.target.closest("[data-next-level]");
      if (!nextLevelBtn) return;

      stack.push({
        level: Number(nextLevelBtn.dataset.nextLevel),
        menuId: nextLevelBtn.dataset.menuId,
        title: nextLevelBtn.dataset.title || "",
      });

      render();
    });

    if (backBtn) {
      backBtn.addEventListener("click", () => {
        if (stack.length > 1) {
          stack.pop();
        }

        render();
      });
    }

    setActiveTab("shop", true);
  }

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  function updateHeaderOnScroll() {
    if (!headerWrapper) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (headerWrapper.classList.contains("is-mega-open")) {
      headerWrapper.classList.remove("is-hidden");
      headerWrapper.classList.add("is-visible");
      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    if (scrollTop < 80) {
      headerWrapper.classList.remove("is-hidden");
      headerWrapper.classList.add("is-visible", "static");
    } else if (scrollTop > lastScrollTop) {
      headerWrapper.classList.add("is-hidden");
      headerWrapper.classList.remove("is-visible", "static");
    } else {
      headerWrapper.classList.remove("is-hidden");
      headerWrapper.classList.add("is-visible");
      headerWrapper.classList.remove("static");
    }

    lastScrollTop = Math.max(scrollTop, 0);
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderOnScroll);
        ticking = true;
      }
    },
    { passive: true },
  );

  updateHeaderOnScroll();
});

function initMobileBannerSlider(scope = document) {
  const slider = scope.querySelector("[data-banner-slider]");
  if (!slider) return;

  const track = slider.querySelector("[data-banner-track]");
  const dotsWrap = slider.querySelector("[data-banner-dots]");

  if (!track || !dotsWrap) return;

  const slides = [...track.querySelectorAll(".as-mob-banner--small")];

  if (slides.length <= 1) return;

  dotsWrap.innerHTML = slides.map(() => "<span></span>").join("");

  const dots = [...dotsWrap.children];

  const setActive = (index) => {
    dots.forEach((dot) => dot.classList.remove("is-active"));
    dots[index]?.classList.add("is-active");
  };

  setActive(0);

  let raf = null;

  track.addEventListener(
    "scroll",
    () => {
      if (raf) cancelAnimationFrame(raf);

      raf = requestAnimationFrame(() => {
        let best = 0;
        let dist = Infinity;

        slides.forEach((slide, index) => {
          const currentDist = Math.abs(slide.offsetLeft - track.scrollLeft);

          if (currentDist < dist) {
            dist = currentDist;
            best = index;
          }
        });

        setActive(best);
      });
    },
    { passive: true },
  );

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      track.scrollTo({
        left: slides[index].offsetLeft,
        behavior: "smooth",
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileBannerSlider();
});
